<div class="ui-g">
    <div class="ui-g-12 ui-g-nopad">
        <div class="ui-g-10 ui-g-nopad">
            <p-card class="ui-card-shadow">
                <div class="ui-progressSpinner">
                    <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="1" *ngIf="loading">
                </p-progressSpinner>
            </div>
                <ng-template appHeader></ng-template>
                <div class="task-counters">
                    <app-task-counter *ngIf="!loading"></app-task-counter>
                    <app-expense-counter *ngIf="!loading && canAccessExpense"></app-expense-counter>
                    <app-offer-counter *ngIf="!loading && canAccessOffer"></app-offer-counter>
                </div>
            </p-card>
        </div>
        <div class="ui-g-2 ui-custom-leftpad ui-custom-stretch">
            <p-card>
                <ul class="property-links">
                    <li *ngIf="canAccessLibrary"><a (click)="navigateUri('library')"><i class="fa fa-file" aria-hidden="true"></i>Library</a> </li>
                    <li *ngIf="canViewMessages"><a (click)="navigateUri('noteSummaryAll')"><i class="fa fa-inbox" aria-hidden="true"></i>Inbox ({{messageCount}})</a> </li>
                    <li *ngIf="canAddMessage"><a (click)="navigateUri('noteSummaryAdd')"><i class="fa fa-envelope" aria-hidden="true"></i>Add Message</a> </li>
                    <li *ngIf="canViewNotes"><a (click)="navigateUri('propertyNotes')"><i class="fa fa-sticky-note" aria-hidden="true"></i>Notes</a></li>
                </ul>
            </p-card>
        </div>
    </div>
    
    <div class="ui-g-12 ui-custom-toppad" [ngClass]="{'summary-view': canViewHeaderSummary}">
        <app-header-summary *ngIf="!loading && canViewHeaderSummary" 
            [propertyStrategy]="propertyStrategy"
            [showTitle]="true">
        </app-header-summary>
    </div>
</div>